import { render } from "./PerformanceEvaluationViewOnly.vue?vue&type=template&id=7410d99e&scoped=true&lang=html"
import script from "./PerformanceEvaluationViewOnly.vue?vue&type=script&lang=js"
export * from "./PerformanceEvaluationViewOnly.vue?vue&type=script&lang=js"

import "./PerformanceEvaluationViewOnly.vue?vue&type=style&index=0&id=7410d99e&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-7410d99e"

export default script